import { render, staticRenderFns } from "./CLinkSelector.vue?vue&type=template&id=237d4c4a"
import script from "./CLinkSelector.vue?vue&type=script&lang=js"
export * from "./CLinkSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports